import React from "react";

export default function KeyHint({ keyLabel, children, variant = "light" }) {
  return (
    <span className="inline-flex items-center gap-2">
      <span
        className={
          variant === "dark"
            ? "keycap keycap-on-dark"
            : "keycap"
        }
      >
        {keyLabel}
      </span>
      {children && <span className="text-xs opacity-80">{children}</span>}
    </span>
  );
}
